import React from "react";
import { useAuth } from "../context/AuthContext";
import { useT } from "../i18n";
import { Button } from "../components/ui/button";
import { Clock, Mail } from "lucide-react";
import PwaIcon from "../components/PwaIcon";

const ADMIN_EMAIL = "antoniosoverato@gmail.com";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const { t } = useT();

  const isDisabled = user && user.is_active === false;
  const isExpired = user && user.is_active !== false && user.activated_until && new Date(user.activated_until) < new Date();

  const title = isDisabled
    ? t("pending.title.disabled")
    : isExpired ? t("pending.title.expired") : t("pending.title.pending");

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="pending-approval-page">
      <header className="pt-safe pt-10 px-7">
        <div className="flex items-center gap-2">
          <PwaIcon size={32} />
          <span className="font-heading text-base font-semibold">Niper</span>
        </div>
      </header>

      <div className="flex-1 flex flex-col justify-center px-7">
        <div className="w-20 h-20 rounded-3xl bg-fresh-yellow-soft text-fresh-yellow-text flex items-center justify-center mb-6">
          <Clock className="w-9 h-9" />
        </div>
        <h1 className="font-heading text-4xl font-medium tracking-tight leading-tight" data-testid="pending-title">
          {title}
        </h1>
        <p className="mt-4 text-zinc-600 text-base leading-relaxed">
          {isDisabled ? t("pending.body.disabled") : t("pending.body.expired")}
          <br />
          {t("pending.body.contact", { email: "" })}{" "}
          <a className="text-zinc-950 font-semibold underline" href={`mailto:${ADMIN_EMAIL}`}>{ADMIN_EMAIL}</a>.
        </p>

        <div className="mt-8 rounded-2xl border border-zinc-200 p-4">
          <div className="text-[11px] tracking-widest uppercase font-bold text-zinc-500">{t("pending.account.title")}</div>
          <div className="mt-2 flex items-center gap-3">
            {user?.picture ? (
              <img src={user.picture} alt="" className="w-10 h-10 rounded-full" />
            ) : (
              <div className="w-10 h-10 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-500 font-heading font-semibold">
                {(user?.name || user?.email || "?").slice(0, 1).toUpperCase()}
              </div>
            )}
            <div className="min-w-0">
              <div className="font-medium truncate">{user?.name || user?.email}</div>
              <div className="text-xs text-zinc-500 truncate">{user?.email}</div>
            </div>
          </div>
        </div>

        <a
          href={`mailto:${ADMIN_EMAIL}?subject=Niper%20account`}
          className="mt-6 w-full h-12 rounded-xl bg-zinc-950 text-white flex items-center justify-center font-bold text-sm active:scale-95"
          data-testid="contact-admin-btn"
        >
          <Mail className="w-4 h-4 mr-2" /> {t("pending.contact_btn")}
        </a>
        <Button onClick={logout} variant="secondary" className="mt-3 w-full h-11 rounded-xl bg-zinc-100 text-zinc-700" data-testid="pending-logout-btn">
          {t("pending.logout_btn")}
        </Button>
      </div>
    </div>
  );
}
